import { createAction } from '@ngrx/store';

export const loadApp = createAction('[App] Load App');

export const loadAppSuccess = createAction('[App] Load App Success');

export const loadAppFailure = createAction('[App] Load App Failure');

export const setAppData = createAction(
  '[App] Set App Data',
  (data: { prfyear: number; prfnumber: number; prfname: string }) => ({ data })
);

export const clearCompanyInfo = createAction('[App] Clear Company Info');

export const setCompanyInfo = createAction(
  '[App] Set Company Info',
  (payload: { groupcode: string; prfnumber: string; prfname: string; prfyear: number; groupreportenabled?: string; prfstatus?: string }) => payload
);

export const loadCompanyInfo = createAction(
  '[App] Load Company Info',
  (payload: { groupcode: string; prfnumber: string; prfyear: number }) => payload
);


export const getCompanyInfo = createAction(
  '[App] Get Company Info',
  (payload: { groupcode: string; prfnumber: string; prfyear: number }) => payload
);

export const getCompanyInfoSuccess = createAction(
  '[App] Get Company Info Success',
  (companyInfo: any) => ({ companyInfo })
);

export const getCompanyInfoFailure = createAction(
  '[App] Get Company Info Failure',
  (error: any) => ({ error })
);
